import {Select, PlotTypeSelector, RangeDiscrete, Switch} from 'svelte-controls-basic';

export function getPlotAcceptanceControls(res) {

   const resIDs = Object.keys(res);
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Result', props: {options: resIDs}},
      transType: { el: Select, hidden: false, default: 'no', label: 'Transform', props: {options: ['no', 'log']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
      colorBy: {el: Select, hidden: true, default: 'roles', label: 'Color by', props: {options: ['roles', 'classes']}},
   };

   return controls;
}

export function getPlotClassStatControls(resIDs) {

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      zoom: { el: Switch, hidden: false, default: false, label: 'Zoom', props: {options: ['off', 'on']}},
   };

   return controls;
}

export function getPlotDistanceControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];

   const controls = {
      ncomp: { el: RangeDiscrete, hidden: false, default: resobj.ncomp > 1 ? 2 : 1, label: '# PCs', props: {min: 1, max: resobj.ncomp}},
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      transType: { el: Select, hidden: false, default: 'no', label: 'Transform', props: {options: ['no', 'log']}},
      limType: { el: Select, hidden: false, default: 'classic', label: 'Limits', props: {options: ['classic', 'robust']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   if (resobj.classNames && resobj.classNames.length > 1) {
      controls['colorBy'] = { el: Select, hidden: false, default: 'none', label: 'Color by', props: {options: ['none', 'groups']}}
   }
   return controls;
}


export function getPlotDistancesControls(res) {

   const resIDs = Object.keys(res);
   const options = resIDs.concat(['both', 'diff']);

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Result', props: {options: options}},
      distType: { el: Select, hidden: false, default: 'h', label: 'Distance', props: {options: ['h', 'q', 'f']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotDoFControls() {
   const controls = {
      dfID: { el: Select, hidden: false, default: 'both', label: 'DoF type', props: {options: ['both', 'Nh', 'Nq']}},
   };
   return controls;
}

export function getPlotEigenvaluesControls(model) {

   const controls = {
      plotType: { el: PlotTypeSelector, hidden: false, default: 'b', label: 'Plot type', props: {options: ['b', 'h']}},
      transform: { el: Select, hidden: false, default: 'none', label: 'Type', props: {options: ['none', 'sqrt', 'log']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotSelectivityControls(resIDs) {
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Results', props: {options: resIDs}},
   };

   return controls;
}

export function getPlotAliensControls(resIDs) {
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Results', props: {options: resIDs}},
   };

   return controls;
}


export function getPlotExtremesControls(resIDs) {
   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Results', props: {options: resIDs}},
   };

   return controls;
}


export function getPlotLoadingsControls(model) {

   const controls = {
      plotType: { el: PlotTypeSelector, hidden: false, default: 'p', label: 'Plot type', props: {options: ['p', 'l', 'h']}},
      comp2: { el: RangeDiscrete, hidden: false, default: model.ncomp > 1 ? 2 : 1, label: 'PC (y-axis)', props: {min: 1, max: model.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'PC (x-axis)', props: {min: 1, max: model.ncomp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
      axesEqual: { el: Switch, hidden: false, default: false, label: 'Axes', props: {options: ['normal', 'equal']}},
   };

   return controls;
}


export function getPlotScoresControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];
   const colorByOptions = resobj.classNames && resobj.classNames.length > 1 ? ['none', 'groups', 'variable'] : ['none', 'variable'];

   const controls = {
      plotType: { el: PlotTypeSelector, hidden: false, default: 'p', label: 'Plot type', props: {options: ['p', 'l', 'h']}},
      comp2: { el: RangeDiscrete, hidden: false, default: resobj.ncomp > 1 ? 2 : 1, label: 'PC (y-axis)', props: {min: 1, max: resobj.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'PC (x-axis)', props: {min: 1, max: resobj.ncomp}},
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
      showEllipse: { el: Switch, hidden: false, default: false, label: 'T2 ellipse', props: {options: ['hide', 'show']}},
      colorBy: { el: Select, hidden: false, default: 'none', label: 'Color by', props: {options: colorByOptions}},
      colorByVar: { el: RangeDiscrete, hidden: true, default: 1, label: 'Variable', props: {min: 1, max: resobj.ncols}},
      confEllipse: { el: Select, hidden: true, default: 'none', label: 'Conf ellipse', props: {options: ['none', '90', '95', '99']}},
   };

   return controls;
}

export function getPlotVarianceControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];

   const controls = {
      plotType: { el: PlotTypeSelector, hidden: false, default: 'b', label: 'Plot type', props: {options: ['b', 'h']}},
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      varType: { el: Select, hidden: false, default: 'explained', label: 'Type', props: {options: ['explained', 'residual']}},
      varForm: { el: Select, hidden: false, default: 'cumulative', label: 'Form', props: {options: ['individual', 'cumulative']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotBiControls(res) {

   const resIDs = Object.keys(res);
   const resobj = res[resIDs[0]];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: resIDs[0], label: 'Show', props: {options: resIDs}},
      comp2: { el: RangeDiscrete, hidden: false, default: resobj.ncomp > 1 ? 2 : 1, label: 'PC (y-axis)', props: {min: 1, max: resobj.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'PC (x-axis)', props: {min: 1, max: resobj.ncomp}},
      showLabels: { el: Select, hidden: false, default: 'hide', label: 'Labels', props: {options: ['hide', 'obj', 'var', 'both']}},
      axesEqual: { el: Switch, hidden: false, default: false, label: 'Axes', props: {options: ['normal', 'equal']}},
   };

   return controls;
}


/*********************************/
/* PLS specific                  */
/*********************************/

export function getPlotPLSVarianceControls(res) {

   const resIDs = Object.keys(res);
   const options = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: defaultOption, label: 'Show', props: {options: options}},
      varSet: { el: Select, hidden: false, default: 'X', label: 'Variance for', props: {options: ['X', 'Y']}},
      varType: { el: Select, hidden: false, default: 'explained', label: 'Type', props: {options: ['explained', 'residual']}},
      varForm: { el: Select, hidden: false, default: 'cumulative', label: 'Form', props: {options: ['individual', 'cumulative']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotFoMControls(res, nresp) {

   const resIDs = Object.keys(res);
   const options = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const foms = ['rmse', 'r2', 'slope'];
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];


   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: defaultOption, label: 'Show', props: {options: options}},
      fom: { el: Select, hidden: false, default: 'rmse', label: 'FoM', props: {options: foms}},
      resp: { el: RangeDiscrete, hidden: nresp < 2, default: 1, label: 'Response', props: {min: 1, max: nresp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotPredictionsControls(res, nresp) {

   const resIDs = Object.keys(res);
   const options = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const resobj = res[resIDs[0]];
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: defaultOption, label: 'Show', props: {options: options}},
      resp: { el: RangeDiscrete, hidden: nresp < 2, default: 1, label: 'Response', props: {min: 1, max: nresp}},
      showStat: { el: Switch, hidden: resobj.Yref === null, default: false, label: 'FoM', props: {options: ['hide', 'show']}},
      showLabels: { el: Select, hidden: false, default: 'hide', label: 'Labels', props: {options: ['hide', 'labels', 'values']}},
   };

   return controls;
}


export function getPlotPLSScoresControls(res) {

   const resIDs = Object.keys(res);
   const options = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const resobj = res[resIDs[0]];
   const varSetOptions = resobj.Yref ? ['X', 'Y', 'XY'] : ['X'];
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];

   const controls = {
      resID: { el: Select, hidden: resIDs.length === 1, default: defaultOption, label: 'Show', props: {options: options}},
      varSet: { el: Select, hidden: resobj.Yref === null, default: 'X', label: 'Scores for', props: {options: varSetOptions}},
      comp2: { el: RangeDiscrete, hidden: false, default: resobj.ncomp > 1 ? 2 : 1, label: 'LV (y-axis)', props: {min: 1, max: resobj.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'LV (x-axis)', props: {min: 1, max: resobj.ncomp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotPLSLoadingsControls(model, ncomp) {

   const controls = {
      statType: { el: Select, hidden: false, default: 'xloadings', label: 'Show', props: {options: ['xloadings', 'weights']}},
      plotType: { el: PlotTypeSelector, hidden: false, default: 'p', label: 'Plot type', props: {options: ['p', 'l', 'h']}},
      comp2: { el: RangeDiscrete, hidden: false, default: model.ncomp > 1 ? 2 : 1, label: 'LV (y-axis)', props: {min: 1, max: model.ncomp}},
      comp1: { el: RangeDiscrete, hidden: false, default: 1, label: 'LV (x-axis)', props: {min: 1, max: model.ncomp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}


export function getPlotPLSDistanceControls(res) {

   const resIDs = Object.keys(res);
   const resIDOptions = resIDs.length > 1 ? [...resIDs, 'both'] : resIDs;
   const resobj = res[resIDs[0]];
   const defaultOption = resIDs.length > 1 ? 'both' : resIDs[0];

   const distTypeOptions = resobj.Yref ? ['h/q', 'f/z'] : ['h/q'];

   const controls = {
      resID: { el: Select, hidden: resIDs.length == 1, default: defaultOption, label: 'Show', props: {options: resIDOptions}},
      distType: { el: Select, hidden: resobj.Yref === null, default: 'h/q', label: 'Show', props: {options: distTypeOptions}},
      transType: { el: Select, hidden: false, default: 'no', label: 'Transform', props: {options: ['no', 'log']}},
      limType: { el: Select, hidden: false, default: 'classic', label: 'Limits', props: {options: ['classic', 'robust']}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}


export function getPlotRegcoeffsControls(nresp) {

   const controls = {
      plotType: { el: PlotTypeSelector, hidden: false, default: 'l', label: 'Plot type', props: {options: ['l', 'h']}},
      resp: { el: RangeDiscrete, hidden: nresp < 2, default: 1, label: 'Response', props: {min: 1, max: nresp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotPLSVarselControls(nresp) {

   const controls = {
      yset: { el: Select, hidden: false, default: 'vip', label: 'Y-axis', props: {options: ['vip', 'selratio']}},
      xset: { el: Select, hidden: false, default: 'values', label: 'X-axis', props: {options: ['values', 'indices', 'vip']}},
      resp: { el: RangeDiscrete, hidden: nresp < 2, default: 1, label: 'Response', props: {min: 1, max: nresp}},
      showLabels: { el: Switch, hidden: false, default: false, label: 'Labels', props: {options: ['hide', 'show']}},
   };

   return controls;
}

export function getPlotPVScalarsControls() {

   const controls = {
   };

   return controls;
}
